import type React from 'react';
import {Typography} from '@mui/material';
import {OVERVIEW_HELP} from '../../domain/overviewHelp';
import {ProfileSection} from '../components/ProfileSection';

/**
 * Specifications and standardisation (spec 4.4). The clusters, variants and savings are worked out in Material
 * Harmonization; this section only describes them until the profile can read the harmonization results per category.
 */
export const SpecificationsSection: React.FC<{categoryName: string}> = ({categoryName}) => (
    <ProfileSection title="Specifications and standardisation" help={OVERVIEW_HELP.specifications}>
        <Typography variant="body2" color="text.secondary">
            {`Overlapping specifications in ${categoryName}, the business units that buy them and the proposed standard are
            reviewed in Material Harmonization.`}
        </Typography>
    </ProfileSection>
);
